// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"9337":"589d8a59a4be3154","9721":"10cec4da7984f239","52002":"e3ca36435cb7915e"}[chunkId] + ".css";
};